import React from 'react'
import Box from '@material-ui/core/Box'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import Button from '@material-ui/core/Button'
import { Icon } from '@iconify/react'
import closeIcon from '@iconify/icons-eva/close-circle-outline'
import Table from './table'
import Typography from '@material-ui/core/Typography'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import ClickAwayListener from '@material-ui/core/ClickAwayListener'

const UserBreaklistModal = ({breaklistId = '', breaklist = [], onClose = () => {}, onSave = () => {}, name = ''}) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	
	return (
		<Modal 
		  aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={true}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
     	
		>
			<div>
				<Fade in={true}>
			    <Box
			      sx={{
			        position: 'absolute',
			        top: '50%',
			        left: '50%',
			        transform: 'translate(-50%, -50%)',
			        width: isMobile ? '95%' : '90%', 
			        maxHeight: isMobile ? '90vh' : '80vh', 
			        overflowY: 'auto',
			        bgcolor: 'background.paper',
			        boxShadow: 24,
			        p: isMobile ? 2 : 4,
			        borderRadius: 2,
			      }}
			    >	
					<Button sx={{ position: 'absolute', right: 1, top: 12, zIndex: 10 }} onClick={onClose}>
			      		<Icon icon={closeIcon} width={25} height={25} color="#b2b2b2" />
			    	</Button>
			    	<Typography variant="h5" align="center" gutterBottom>
						{name}
					</Typography>
            <Box sx={{ 
				display: 'flex', 
				flexDirection: isMobile ? 'column' : 'row',
				alignItems: 'center', 
				justifyContent: 'center', 
				gap: isMobile ? 1 : 2, 
				mb: 2 
			}}>
              <Typography variant="body2" color="text.secondary" align={isMobile ? "center" : "left"}>
				Highlighted values are editable by clicking on them
			  </Typography>
              <Button 
                variant="contained" 
                color="primary" 
                size="small"
                onClick={onSave}
				sx={{ mt: isMobile ? 1 : 0 }}
              >
                Refresh Changes
              </Button>
            </Box>
			    	<Table breaklistId={breaklistId} breaklist={breaklist} onSave={onSave} />
			    </Box>
			  </Fade>
			</div>
		</Modal>
	)	
}

export default UserBreaklistModal
